import React from 'react';
import type { WrapPageElementBrowserArgs, WrapPageElementNodeArgs } from 'gatsby';
import { LocaleProvider } from './context';

type WrapPageArgs = WrapPageElementBrowserArgs | WrapPageElementNodeArgs;

export function wrapWithLocale({ element, props }: WrapPageArgs): React.JSX.Element {
  return <LocaleProvider pageContext={props.pageContext}>{element}</LocaleProvider>;
}
